// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2Kvsx","loaderOuter":"PageOverlayLoader_loaderOuter__2lnBd"};